import TabbedDisplay from 'modules/TabbedDisplay'

import ResearchBriefsPage from 'routes/common/FullReportPage/components/ResearchBriefs'

import { TableauEmbed } from 'components'

import { ISingleCustomPage } from 'interfaces/navigationPage.interface'

import { RSVEpidemiologySlugs } from './RSVEpidemiologyMenu'
import EpidDashboard from 'modules/EpidDashboard'

const EpidemiologyAcrossRespiratoryDiseases: ISingleCustomPage<RSVEpidemiologySlugs> =
  {
    path: 'epidemiology-across-respiratory-diseases',
    component: () => <EpidDashboard />,
  }

const Severity: ISingleCustomPage<RSVEpidemiologySlugs> = {
  path: 'hospitalisations',
  component: () => (
    <TabbedDisplay
      tabs={[
        {
          heading: 'Hospitalisations',
          body: (
            <TableauEmbed path='/FRONTENDRSVdashboards/Hospitalisations_1' />
          ),
        },
        {
          heading: 'Hospitalisations by Age',
          body: (
            <TableauEmbed path='/FRONTENDRSVdashboards/HospitalisationsbyAge' />
          ),
        },
      ]}
    />
  ),
}

const ResearchBriefs: ISingleCustomPage<RSVEpidemiologySlugs> = {
  path: 'research-briefs',
  component: () => <ResearchBriefsPage />,
}

export const RSVEpidemiologyCustomPages: Record<
  string,
  ISingleCustomPage<RSVEpidemiologySlugs>
> = {
  EpidemiologyAcrossRespiratoryDiseases,
  Severity,
  ResearchBriefs,
}
